<template>
  <el-drawer v-model="visible" custom-class="pro-drawer" size="30%" destroy-on-close :title="rowData.name">
    <template #title>
      <h4>{{ rowData.name }}</h4>
    </template>

    <project-info v-if="rowData.type === 'PROJECT'" :project="rowData" />
    <team-info v-else-if="rowData.type === 'TEAM'" :team="rowData" />
    <group-info v-else-if="rowData.type === 'GROUP'" :group="rowData" />
  </el-drawer>
</template>
<script>
import { defineComponent } from "vue";
import ProjectInfo from './ProjectInfo.vue';
import TeamInfo from './TeamInfo.vue';
import GroupInfo from './GroupInfo.vue';
export default defineComponent({
  components: { ProjectInfo, TeamInfo, GroupInfo },
  emits: ["update:modelValue"],
  props: {
    modelValue: Boolean,
    rowData: Object
  },
  watch: {
    visible(val) {
      if (!val) {
        return;
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  }
});
</script>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
</style>